import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sidenav-item',
  templateUrl: './sidenav-all-item.component.html',
  styleUrls: ['./sidenav-all-item.component.css']
})
export class SidenavItemComponent implements OnInit {
  @Output() sidenavItemClose = new EventEmitter();
  @Input() urlList;
  @Input() urlName;


  constructor() { }

  ngOnInit() {
    console.log('side1', this.urlName, this.urlList);
  }

  public onSidenavClose = () => {
    this.sidenavItemClose.emit();
  }

}
